<!--
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2026-03-27 09:23:05
 * @Description: 数据管理
 * @FilePath: \web\src\components\DataManagement\management\index.vue
-->
<template>
  <div class="data-management">
    <div class="search-container">
      <SearchModule @submit="searchHandle" />

      <div class="crud-wrapper">
        <div class="crud-item crud-item-jump" @click="batchFollow()">关注</div>
        <div class="crud-item crud-item-jump" @click="jumpChineseFundedOverseas()">项目展示</div>

        <div class="crud-item" @click="importData()">导入</div>
        <div class="crud-item" @click="add()">新增</div>
        <div class="crud-item" @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          删除
        </div>

        <div class="crud-item" @click="selectDownload()" :class="crud - item - abled">
          导出
        </div>
      </div>
    </div>

    <a-table rowKey="id" class="management-table" :dataSource="industryPages" :loading="industryPagesLoading"
      :columns="columns" @change="changePage" :row-selection="rowSelection" :scroll="{ y: '90%' }"
      :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>

      <template #primaryCommodity="{ record }">
        <img class="primary-commodity-img" :src="getMineralImage(record)" alt="" srcset="" />
      </template>

      <template #commoditiesList="{ text: commoditiesList }">
        <span>
          <a-tag v-for="(item, index) in commoditiesList ? commoditiesList.split(',') : []" :key="index">{{
            item
          }}</a-tag>
        </span>
      </template>

      <template #action="{ record }">
        <section class="action-icons">

          <i class="crud-item-abled" v-if="!record.followFlag"
            v-bind="{ style: 'color: rgb(255, 255, 255)', class: 'iconfont icon-wodeguanzhu', title: '关注', }"
            @click="changeFollowFlag(record.id, false)"></i>
          <i class="crud-item-abled" v-if="record.followFlag"
            v-bind="{ style: 'color: rgb(255, 200, 120)', class: 'iconfont icon-wodeguanzhu', title: '取消关注', }"
            @click="changeFollowFlag(record.id, true)"></i>

          <i v-for="(item, index) in tableOperationList" :key="index" v-bind="item.option" @click="item.click(record)">
          </i>
          <div class="crud-wrapper" v-if="!record.label">
            <i class="crud-item1" :class="record.label ? 'crud-item-disabled' : 'crud-item-abled'"
              v-bind="{ class: 'iconfont icon-xiangpica', title: '中资海外', }"
              @click="chineseFundedOverseasRecord(record)"></i>
            <i class="crud-item1" :class="record.label ? 'crud-item-disabled' : 'crud-item-abled'"
              v-bind="{ class: 'iconfont icon-goodsppecategory', title: '海外推介', }"
              @click="overseasPromotionRecord(record)"></i>
          </div>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <a-textarea v-model:value="confirmModalConf.remark" placeholder="请填写备注" :rows="8"
          v-if="confirmModalConf.showRemark" />

        <FileUpload v-else-if="confirmModalConf.showUpload" @fileList="importFileList" uploadType="xmk" />

        <TypeList :option="confirmModalConf" v-else-if="confirmModalConf.showDown" />

        <section v-else-if="confirmModalConf.report">
          <section class="detail-modal-container">
            <img class="img_ky_bg" :src="baseUrl + confirmModalConf.imgUrl" alt="图片加载失败">
          </section>
        </section>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->

    <PopupModal :option="modalOption" v-if="modalOption.visible" :loading="modalOption.loading"
      :dataList="modalOption.datalist" :modalType="modalOption.modalType" @search="modalRequest"
      @seeReport="seeReport" />
    <!-- / 新增编辑弹窗 -->
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, unref, } from 'vue';
import { useStore, } from 'vuex';
import { useRouter, } from 'vue-router';
import { message, } from 'ant-design-vue';
import Modal from '@/components/lib/Modal/modal1.vue';
import PopupModal from '@/components/lib/Modal/modal.vue';
import { GET_MANAGEMENT_INDUSTRY_PAGE, } from '@/store/modules/actions/dataManagement.js';
import { getInfoAllApi, } from '@/api/projectLibrary/projectLibraryApi';
import {
  removeProjectApi,
  industryExportApi,
  industryImportApi,
  operationUpdate,
  batchFollowApi,
  followProjectApi,
  cancelProjectApi,
} from '@/api/dataManagement/dataManage';
import { loadReportApi } from '@/api/utils/utilsApi'
import qs from 'qs';
import AxiosCancelToken from '@/utils/axiosCancelToken';
import { getMineralImage, downLoadUtil, } from '@/components/utils/utils';
import config from '@/config/config';
import TypeList from '@/components/DataManagement/component/typeList.vue';
import SearchModule from '../component/search.vue';
import FileUpload from '@/components/lib/Upload/fileUpload1.vue';
import tableConfig from './tableConfig.js';
const {
  serveIp: { mine_ip, },
} = config;
const axiosCancelToken = new AxiosCancelToken();

const columns = tableConfig;

const router = useRouter();

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
const store = useStore()
// state
const dataManagementState = computed(() => state.dataManagement);
const { requestParams, industryPages, totalCount, industryPagesLoading, orenodeResultVisible, activeKey, } = toRefs(
  dataManagementState.value
);
const getRequestParams = computed(() => store.getters)
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'dataManagement'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'dataManagement'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id
const selectType = ref('page');
const baseUrl = window.location.origin;

const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  showUpload: false,
  showDown: false,
  selectValue: [],
  fileList: [],
  codeType: false,
  exportIds: '',
});

// 新增编辑弹窗 公用
const modalOption = reactive({
  visible: false,
  loading: false,
  datalist: {},
  modalType: 'default',
});

/**
 * @description 表格选中事件
 */
const selectedRowKeys = ref([]); // Check here to configure the default column

const onSelectChange = changableRowKeys => {
  selectedRowKeys.value = changableRowKeys;
  selectedKeys.value = changableRowKeys;
};

const rowSelection = computed(() => {
  // 因导出全部后台会卡死，根据陶总和大伟要求修改为值导出本页
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
    hideDefaultSelections: true,
    selections: [
      {
        key: 'page',
        text: '本页全选',
        onSelect: changableRowKeys => {
          let newSelectedRowKeys = [];

          selectType.value = 'page';

          newSelectedRowKeys = changableRowKeys.filter((key, index) => {
            // if (index % 2 !== 0) {
            //   return false;
            // }
            return true;
          });
          selectedRowKeys.value = newSelectedRowKeys;
        },
      },
      {
        key: 'all',
        text: '全部全选',
        onSelect: changableRowKeys => {
          let newSelectedRowKeys1 = [];

          selectType.value = 'all';
          newSelectedRowKeys1 = changableRowKeys.filter((key, index) => {
            // if (index % 2 !== 0) {
            //   return false;
            // }
            return true;
          });
          selectedRowKeys.value = newSelectedRowKeys1;
        },
      },
      //     {
      //       key: 'page',
      //       text: '取消选择',
      //       onSelect: changableRowKeys => {
      //         let newSelectedRowKeys = [];

      //         selectType.value = 'page';

      //         newSelectedRowKeys = changableRowKeys.filter((key, index) => {
      //           // if (index % 2 !== 0) {
      //           //   return false;
      //           // }
      //           return false;
      //         });
      //         selectedRowKeys.value = newSelectedRowKeys;
      //       },
      //     },
    ],
  };
});


/**
 * @description 单行数据详情跳转
 */
const detailRecord = (record) => {
  const { id, } = record;

  modalOption.loading = true;
  modalOption.modalType = 'default';
  getInfoAllApi(id, { params: { sn: '', }, })
    .then((d) => {
      modalOption.loading = false;
      modalOption.datalist = d;
    })
    .catch(() => {
      modalOption.visible = false;
    });

  modalOption.visible = true;
};

/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_MANAGEMENT_INDUSTRY_PAGE);
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};

/* 海外推介大屏展示数据推送 */
const overseasPromotioProject = (record) => {
  // record.label = '推介项目';
  // record.show = 1;
  const params = {
    id: record.id,
    label: '推介项目',
    show: 1,
  };

  operationUpdate(params).then((res) => {
    confirmModalConf.visible = false;
    confirmModalConf.codeType = false;
    searchHandle();
  });
};
const beforeOverseasPromotion = (record) => {
  confirmModalConf.title = '确认推送至海外推介项目吗？';
  confirmModalConf.callback = () => overseasPromotioProject(record);
  confirmModalConf.visible = true;
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = false;
  confirmModalConf.showDown = false;
};
const overseasPromotionRecord = (record) => {
  beforeOverseasPromotion(record);
};
/* 中资海外大屏展示数据推送 */
const chineseFundedOverseasProject = (record) => {
  const params = {
    id: record.id,
    label: '海外项目',
    show: 1,
  };

  operationUpdate(params).then((res) => {
    confirmModalConf.visible = false;
    confirmModalConf.codeType = false;
    searchHandle();
  });
};
const beforeChineseFundedOverseas = (record) => {
  confirmModalConf.title = '确认推送至中资海外项目吗？';
  confirmModalConf.callback = () => chineseFundedOverseasProject(record);
  confirmModalConf.visible = true;
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = false;
  confirmModalConf.showDown = false;
};
const chineseFundedOverseasRecord = (record) => {
  beforeChineseFundedOverseas(record);
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = false;
  confirmModalConf.showDown = false;
  confirmModalConf.codeType = false;
  confirmModalConf.width = '';
  confirmModalConf.imgUrl = '';
  confirmModalConf.reportFileid = '';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

// -------------------- 删除
/**
 * @description 删除项目
 */
const delProject = (ids) => {
  const requestData = ids.map((i) => ({ id: i, remark: confirmModalConf.remark, }));

  removeProjectApi(requestData).then((res) => {
    confirmModalConf.visible = false;
    confirmModalConf.codeType = false;
    searchHandle();
  });
};

/**
 * @description 删除项目之前
 */
const beforeDel = (ids) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认删除项目？';
  confirmModalConf.callback = () => delProject(ids);
  confirmModalConf.visible = true;
};

/**
 * @description 单行数据删除
 */
const delRecord = (record) => {
  const { id, } = record;

  beforeDel([id,]);
};

/**
 * @description 勾选删除
 */
const selectDel = () => {
  let ids = selectedRowKeys.value;

  if (selectType.value === 'all') {
    ids = '';
  }
  beforeDel(ids);
};

// -------------------- 导出

/**
 * @description 开始导出
 */
const downloadProject = (ids) => {
  if (!confirmModalConf.selectValue.length) {
    return message.info('请选择导出信息');
  }

  const queryData = qs.stringify({

    // 因导出全部后台会卡死，根据陶总和大伟要求修改为值导出本页
    ids: selectType.value === 'all' ? '' : ids.join(','),
    // ids: ids.join(','),
    keys: confirmModalConf.selectValue.join(','),
    check: true,
  });


  let q = getRequestParams.value['dataManagement/getRequestParams'];
  q.exportIds = confirmModalConf.exportIds === '' ? [] : confirmModalConf.exportIds.split(',');
  industryExportApi(queryData, q, {
    // // 中断请求
    cancelToken: axiosCancelToken.setToken('/industry/export'),
  }).then((res) => {
    downLoadUtil(res).then(() => {
      confirmModalConf.selectValue = [];
      confirmModalConf.visible = false;
      confirmModalConf.codeType = false;
    });
  });
};

/**
 * @description 导出之前
 * @param {*} ids
 */
const beforeDownload = (ids) => {
  confirmModalConf.showRemark = false;
  confirmModalConf.showDown = true;
  confirmModalConf.title = '导出项目';
  confirmModalConf.callback = () => downloadProject(ids);
  confirmModalConf.visible = true;
  confirmModalConf.codeType = true;
};

/**
 * @description 勾选导出
 */
const selectDownload = () => {
  const ids = selectedRowKeys.value;

  beforeDownload(ids);
};
/**
 * 勾选关注
 */
const batchFollow = () => {
  const ids = selectedRowKeys.value;

  if (selectType.value !== 'all' && ids.length === 0) {
    message.error('请选择关注项目！');
    return;
  }
  const queryData = qs.stringify({
    ids: selectType.value === 'all' ? '' : ids.join(','),
  });

  let q = getRequestParams.value['dataManagement/getRequestParams'];
  batchFollowApi(queryData, q).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      message.success('关注成功！');
      searchHandle();
    } else {
      message.error('关注失败！');
    }
  });
};
/**
 * 修改关注状态
 * @param {关注状态} type true已关注  false 未关注
 */
const changeFollowFlag = (id, type) => {
  if (!type) {
    followProjectApi({ id: id, }).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        message.success('关注成功');
        searchHandle();
      }
    });
  } else {
    cancelProjectApi({ id: id, }).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        message.success('取消关注成功');
        searchHandle();
      }
    });
  }
};
// 海外推介页面跳转
const jumpOverseasPromotion = () => {
  router.push('/main/screen/overseasPromotion');
};
// 中资海外页面跳转
const jumpChineseFundedOverseas = () => {
  router.push('/main/screen/chineseFundedOverseas');
};

/**
 * @description 单行数据下载excel
 */
const downRecord = (record) => {
  const { id, } = record;

  beforeDownload([id,]);
};

/**
 * @description 导入
 */
const importFileList = (data) => {
  confirmModalConf.fileList = data;
};
const xlsxUpload = () => {
  if (confirmModalConf.fileList && confirmModalConf.fileList.length > 0) {
    let formData = new FormData();

    let list = confirmModalConf.fileList;

    list.forEach((file) => {
      formData.append('file', file.originFileObj);
    });

    industryImportApi(formData).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        confirmModalConf.visible = false;
        confirmModalConf.showUpload = false;
        confirmModalConf.fileList = [];
        confirmModalConf.codeType = false;
        dispatch(null, GET_MANAGEMENT_INDUSTRY_PAGE);
      }
    });
  }
};

/**
 * @description 导入按钮点击
 */
const importData = () => {
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = true;
  confirmModalConf.title = '项目导入';
  confirmModalConf.callback = () => xlsxUpload();
  confirmModalConf.visible = true;
};

/**
 * @description 新增
 */
const add = () => {
  modalOption.modalType = 'add';
  modalOption.visible = true;
};

/**
 * @description 新增 或者编辑之后的回调事件
 */
const modalRequest = () => {
  searchHandle();
  dispatch('dataAudit', 'GET_MANAGEMENT_INDUSTRY_PAGE');
};
/**
 * 下载pdf文件
 */
const downLoadFile = () => {
  const id = confirmModalConf.reportFileid.length === 5 ? `0${confirmModalConf.reportFileid}` : confirmModalConf.reportFileid
  loadReportApi(id).then((res) => {
    downLoadUtil(res).then(() => {
      message.success('下载成功！');
    });

  });
};
/**
 * 查看报告
 */
const seeReport = (imgUrl, id) => {
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = false;
  confirmModalConf.report = true;
  confirmModalConf.url = true;
  confirmModalConf.imgUrl = imgUrl;
  confirmModalConf.reportFileid = id;
  confirmModalConf.width = '10rem';
  confirmModalConf.title = '报告预览';
  confirmModalConf.notFootertype = 'downLoad',
    confirmModalConf.callback = () => downLoadFile();
  confirmModalConf.visible = true;
}
const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1, 2,];
//中资海外、海外推介的权限控制
const screenOperationConf = [1,];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-gengduo',
      title: '详情',
    },
    click: detailRecord,
    operation: [1, 2, 3,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-xiazaidaoru',
      title: '下载',
    },
    click: downRecord,
    operation: [1, 2,],
  },
];

onBeforeMount(() => {
  // window.open('/pdf/024434.pdf');
  tableOperationList.value = tableOperationListConf;
  commit(null, 'setRequestParams', { onlyFollow: '', page: 1, size: 6, });
  searchHandle();
});
/**
 * @description 表格数据变化条件 触发接口
 */
watch(
  industryPages,
  (val, old) => {
    if (selectType.value === 'all') {
      val.forEach(item => {
        selectedRowKeys.value.push(item.id);
      });
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
</script>

<style lang="scss">
.data-management {
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  /* 检索条件 */
  .search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0.1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item-jump {
        width: 0.7rem;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 矿种图标 */
  .minerals-img {
    width: 0.6rem;
    height: 0.3rem;
  }



  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;

        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .crud-wrapper {
          display: flex;
          height: 0.25rem;

          .crud-item {
            margin-right: 0.04rem;
            width: 0.55rem;
            line-height: 0.25rem;
            font-size: 0.1rem;
            color: #fff;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/curd_btn.png);
            background-size: 100% 100%;
            text-align: center;
          }

          .crud-item:hover {
            cursor: pointer;
          }

          .crud-item-disabled {
            pointer-events: none;
            color: rgba(255, 255, 255, 0.6);
            // background-color: rgba(239, 178, 39, 0.6);
            opacity: 0.8;
          }

          .crud-item-disabled:hover {
            cursor: no-drop;
          }
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>
